import React from "react";
import _ from "lodash";
import {Input} from "@material-ui/core";
import {Tag} from "antd";

const columns = [{
    Header: "All Transaction",
    columns: [
        // {
        //   expander: true,
        //   Header: () => <strong>More</strong>,
        //   width: 65,
        //   Expander: ({ isExpanded, ...rest }) =>
        //     <div>
        //       {isExpanded
        //         ? <span>&#x2299;</span>
        //         : <span>&#x2295;</span>}
        //     </div>,
        //   style: {
        //     cursor: "pointer",
        //     fontSize: 25,
        //     padding: "0",
        //     textAlign: "center",
        //     userSelect: "none"
        //   }
        // },
        {
            Header: "ID",
            accessor: "id",
            width: 70,
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Date/Time",
            style: {textAlign: "center"},
            id: "dateTime",
            accessor: d => {
                return d.dateTime.replace(/T/, " ").replace(/\..+/, "");
            },
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Payer Acc.#",
            accessor: "payerAccountNumber",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Payer U.Name",
            accessor: "payerUserName",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        //   {
        //     Header: 'Payer Pho.#',
        //     accessor: 'payerPhoneNumber',
        //     style: {textAlign:'center'},
        //     Filter: ({ filter, onChange }) => {
        //       return (
        //          <Input
        //               onKeyPress={event => {
        //                   if (event.keyCode === 13 || event.which === 13) {
        //                          onChange(event.target.value)
        //                  }
        //              }}  
        //          />  
        //    )},
        //   },
        {
            Header: "Payer Bank",
            accessor: "payerBank",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Merchant Name",
            accessor: "payeeUserName",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Type",
            accessor: "type",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Category",
            accessor: "paymentCategory",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Response",
            id: "status",
            accessor: d =>
                <Tag
                    color={_.upperCase(d.status) === "SUCCESS" ? "green" : _.upperCase(d.status) === "FAILED" ? "red" : ""}>
                    {_.upperCase(d.status)}
                </Tag>,
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Trn Description",
            accessor: "bankerResponseDesc",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Description",
            accessor: "castomParam",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Commission",
            accessor: "commission",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Currency",
            accessor: "currency",
            width: 70,
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Amount(Rs.)",
            accessor: "originalAmount",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        }
    ]
}];

const usrColumns = [{
    Header: "All Transaction Report",
    columns: [
        {
            Header: "ID",
            accessor: "id",
            width: 70,
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Date/Time",
            style: {textAlign: "center"},
            id: "dateTime",
            accessor: d => {
                return d.dateTime.replace(/T/, " ").replace(/\..+/, "");
            },
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Merchant Name",
            accessor: "payeeUserName",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Type",
            accessor: "type",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Category",
            accessor: "paymentCategory",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Response",
            id: "status",
            accessor: d =>
                <Tag
                    color={_.upperCase(d.status) === "SUCCESS" ? "green" : _.upperCase(d.status) === "FAILED" ? "red" : ""}>
                    {_.upperCase(d.status)}
                </Tag>,
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Trn Description",
            accessor: "bankerResponseDesc",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Description",
            accessor: "castomParam",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        },
        {
            Header: "Amount(Rs.)",
            accessor: "originalAmount",
            style: {textAlign: "center"},
            Filter: ({filter, onChange}) => {
                return (
                    <Input
                        onKeyPress={event => {
                            if (event.keyCode === 13 || event.which === 13) {
                                onChange(event.target.value);
                            }
                        }}
                    />
                );
            },
        }
    ]
}];

const subColumns = [{
    columns: [
        {
            Header: "Description",
            accessor: "description",
            style: {textAlign: "center"}
        },
        {
            Header: "Commission",
            accessor: "commission",
            style: {textAlign: "center"}
        },
    ]
}];

export {columns, subColumns, usrColumns};